import React, { Component } from 'react';
import '../../inc/genstyle.css';
import '../iinc/iGlobal';
import RandomNumber from '../../inc/random-number';
import { FormErrors } from '../../inc/error-form';
import IHeader from './ifragmentheader';
import ISidemenu from './ifragmentsidemenu';
import INA from './ifragmentna';
import ReplaceAllContent from '../../inc/replace-all';
import MyCustomUploadAdapterPlugin from '../iinc/ckImageUploader';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const authKey = global.config.authBearerKey+"##"+global.config.kindcode[49];

class IGCPBudgetsMsgTemplate extends Component {
  constructor (props) {
    super(props);
    this.state = {
        stTitle: '',
        content_types: '',
        
        // Form fields
        isEdit: false,
        msgtemplate_id: '',
        todest: '',
        usagefor: '',
        subject: '',
        message: '',
        formErrors: {todest: '', subject: '', message: ''}, 
        todestValid: false,
        subjectValid: false,
        messageValid: false,
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleUserCKEditorInput = (e) => {
    const name = "message";
    const value = e.getData();
    this.setState({[name]: value},
        () => { this.validateField(name, value)});
  }
  handleInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({[name]: value},
        () => { this.validateField(name, value)});
  }

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let todestValid = this.state.todestValid;
    let subjectValid = this.state.subjectValid;
    let messageValid = this.state.messageValid;

    switch(fieldName) {
        case 'todest': 
            todestValid = value.trim().length > 0;
            fieldValidationErrors.subject = todestValid ? '' : 'destination email need to be filled';
            break;

        case 'subject': 
            subjectValid = value.trim().length > 0;
            fieldValidationErrors.subject = subjectValid ? '' : 'subject need to be filled';
            break;
        case 'message': 
            messageValid = value.trim().length > 0;
            fieldValidationErrors.message = messageValid ? '' : 'message need to be filled';
            break;
        default:
            break;
    }
    //alert(fieldName + ':' + JSON.stringify(fieldValidationErrors));
    
    this.setState({formErrors: fieldValidationErrors,
                      todestValid: todestValid,
                      subjectValid: subjectValid,
                      messageValid: messageValid,
                }, this.validateForm);
  }
  validateForm() {
    // this.setState({formValid: this.state.licencetypeValid && this.state.licenceamountseatValid && this.state.licencepriceValid && this.state.licencestartdateValid && this.state.licenceperiodenumValid && this.state.licencepriceseatValid && this.state.licenceperiodenumbillcycleValid && this.state.licenceperiodeunitbillcycleValid });
    this.setState({formValid: 
      this.state.subjectValid && this.state.messageValid  && this.state.todestValid
    });
  }

  errorClass(error) {
    return(error.length === 0 ? '' : 'has-error');
  }
  handleSubmit(e) {
    e.preventDefault();
    if(this.state.todest !== "" &&  this.state.subject !== "" && this.state.message !== "") {
        document.getElementById('loading-area').style.display = 'block'; 
        var todest,subject,message;
        if(this.textInputToDest.value === '') { todest = this.state.todest; } else { todest = this.textInputToDest.value; }
        if(this.textInputSubject.value === '') { subject = this.state.subject; } else { subject = this.textInputSubject.value; }
        message = this.state.message;
        message = ReplaceAllContent('"',"'",this.state.message);
        
        var data = {
          todest: todest,
          usagefor: this.state.usagefor,
          template_subject: subject,
          template_message: message
        }

        var urlFetch;
        if(this.state.content_types === "edit" && this.state.usagefor !== "") {
            data.msgtemplateid = this.state.msgtemplate_id;
            data.form_id = "form-editmsgtemplate";
            urlFetch = global.config.urlLink+"/gcpbudgetmsgtemplateedit";
        } else {
            data.form_id = "form-addmsgtemplate";
            urlFetch = global.config.urlLink+"/gcpbudgetmsgtemplateadd";
        }
        fetch(urlFetch, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': authKey,
            }, body : JSON.stringify(data)
          }).then(res => {
            if(res.status === 200) 
                return res.json() 
          }).then( resJson => {
            document.getElementById('loading-area').style.display = 'none'; 
            if(resJson.status === '200') {
                var resultid = resJson.values;
                this.loadData(this.state.activelink,this.state.usagefor);
            } else {
                console.log('Something happened wrong');
            }
          }).catch(err => { 
            document.getElementById('loading-area').style.display = 'none'; 
            console.log(err);
          });

    } else {
        var arrfieldName = ['subject','message'];
        var arrvalue = [this.textInputSubject.value,this.textInputMessage.value];
        for(var ck in arrfieldName) {
            this.validateField(arrfieldName[ck], arrvalue[ck]);
        }
    }
  }
  getMessageTemplate = (id) => {
    return new Promise((resolve) => {
      
      fetch(global.config.urlLink+"/gcpbudgetmsgtemplateview/"+id, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }
      }).then(res => {
        if(res.status === 200) 
            return res.json() 
      }).then( resJson => {
        if(resJson.status === "200") { 
          resolve(resJson.values[0]);
        } else {
          resolve([]);
        }
      });
    });
  }
  async loadData(element,id) {
    document.getElementById('loading-area').style.display = 'block'; 
        
    if(element.toLowerCase() === "igcpbudgetmsgtemplate") {
      const [result1] = await Promise.all([this.getMessageTemplate(id)]);
      if(result1) {
        var resultDetail = result1.content[0];
        this.setState({
          activelink: element.toLowerCase(),
          stTitle: 'Edit Template',
          content_types: 'edit',
          
          // Form fields
          isEdit: true,
          msgtemplate_id: resultDetail.id,
          todest: resultDetail.to_dest,
          usagefor: resultDetail.usagefor,
          subject: resultDetail.subject !== null && resultDetail.subject !== undefined? resultDetail.subject : '',
          message: resultDetail.message !== null && resultDetail.message !== undefined? ReplaceAllContent('"',"'",resultDetail.message) : '',

        });
        document.getElementById('loading-area').style.display = 'none'; 
        
      }

    } else if(element.toLowerCase() === "iaddgcpbudget") {
      const [result1,result2] = await Promise.all([this.getCuanCompany(),this.getCuanSubCompany()]);
      if(result1 && result2) {
        this.setState({
          activelink: element.toLowerCase(),
          stTitle: 'New Template',
          content_types: 'add',
        });
        document.getElementById('loading-area').style.display = 'none'; 
        
      }

    } else {
      document.getElementById('loading-area').style.display = 'none'; 
      // window.location.href='/igcpbudget';
    }
  }
  componentDidMount() {
    // var geturl = this.props.location; 
    // var arrString = geturl.pathname;
    var arrString = window.location.pathname; 
    var arrUrl = [];
    arrUrl = arrString.split('/');
    // this.loadData(arrUrl[1],arrUrl[2]);
    this.loadData(arrUrl[1],global.config.gcpbudgetMsgTemplate);
    

  }
  

 render() {
  return (
    <div className="main-container">
      <div  className="header-main"><IHeader/></div>
          <div className="flex-container">
              <div className="sidebar-main"><ISidemenu/></div>
              <div className="main-content">
                <div className="stTitle">Template Alert</div>
                {((localStorage.getItem('ulevel') === global.config.userlevel[0]) || (JSON.parse(localStorage.getItem('urole'))[9] === "ON"))? 
              <div>
                {/* <div className="stIndiTitle">Template Alert { this.state.stTitle !== ''? '> '+this.state.stTitle : '' } </div> */}
                <div className="mgT30">
                    {/* ====== */}
                    <div  className="content-container card card-body">
                        <div className="flex-container">
                            <div className="st2Title w70p">{ this.state.stTitle.includes("New")? '' : '' } {this.state.stTitle}</div>
                            <div className="divRight w30p"><div><button className="backButton" onClick={this.handleBack}>&#9664; back</button></div></div>
                        </div>
                        <div id="FormCenter" className="mgT20">
                            <div id="FormAddContentInfo">
                                {/* PUT FORM IN HERE */}
                                <form onSubmit={this.handleSubmit}>
                                      <div className="row-field mgT50">
                                          <label className="labelFormL" htmlFor="todest">Destination Email</label>
                                          <div className="w60p">
                                              <input type="text" className="form-control" name="todest"
                                                  placeholder="Enter destination email"
                                                  value={this.state.todest}
                                                  onChange={this.handleInput} 
                                                  ref={(input) => this.textInputToDest = input}
                                                  />
                                              <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.todest}/>  }</div>
                                              <div className="mgT10 warningText">
                                                use comma (,) to separate email addresses<br/>eg: email1@example.com,email2@example.com.
                                              </div>
                                          </div>
                                      </div>
                                      <div className="row-field mgT20">
                                          <label className="labelFormL" htmlFor="subject">Subject</label>
                                          <div className="w60p">
                                              <input type="text" className="form-control" name="subject"
                                                  placeholder="Enter subject"
                                                  value={this.state.subject}
                                                  onChange={this.handleInput} 
                                                  ref={(input) => this.textInputSubject = input}
                                                  />
                                              <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.subject}/>  }</div>
                                          </div>
                                      </div>
                                      <div className="row-field mgT20">
                                        <label className="labelFormL" htmlFor="message">Message</label>
                                        <div className="w60p">
                                            <CKEditor
                                                editor  = { ClassicEditor }
                                                name    = "message"
                                                data    = {this.state.message}
                                                config  = {{extraPlugins:[MyCustomUploadAdapterPlugin], state: this.state, key:authKey}}
                                                onReady = { editor => {
                                                    editor.ui.view.editable.element.style.minHeight = "500px";
                                                } }
                                                onChange={ ( event, editor ) => {
                                                    this.handleUserCKEditorInput(editor);
                                                    const data = editor.getData();
                                                    
                                                    editor.ui.view.editable.element.style.minHeight = "500px";
                                                } }
                                                onBlur={ ( event, editor ) => {
                                                    editor.ui.view.editable.element.style.minHeight = "500px";
                                                } }
                                                onFocus={ ( event, editor ) => {
                                                    editor.ui.view.editable.element.style.minHeight = "500px";
                                                } }
                                            />

                                            <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.message}/>  }</div>
                                        </div>
                                      </div>
                                      <div className="row-field mgT30 mgB30">
                                          <div className="labelFormL"></div>
                                          <div className="w60p"><button type="submit" className="w100p submitButton">Submit</button></div>
                                      </div>
                                   
                                </form>
                            </div>
                           
                        </div>
                    </div>
                    {/* ====== */}
                  </div>  
              </div>
              :   
              <div><INA/></div>
              }
              </div>
          </div>
          <div id="loading-area" className="divHide loading"></div> 
    </div>
   );
 }
}
 
export default IGCPBudgetsMsgTemplate;
